<form class="details-screen" [formGroup]="formGroup">
	<bb-page-header [backOnMobile]="['/publication/users']" [icon]="'user'" [title]="isNew ? ('NEW_USER' | translate) : getLabel()">
		
		<ul class="tabs">
			<li>
				<a class="active">
					<i class="fa fa-user"></i> {{ 'DETAILS' | translate }}
				</a>
			</li>
		</ul>

	</bb-page-header>

	<div class="body-column" *ngIf="user && formGroup.controls">

		<div class="left-column">

			<h3>{{'INFORMATION' | translate}}</h3>

			<bb-form-element [control]="formGroup.controls.firstname" [label]="'FIRST_NAME' | translate">
				<input type="text" required formControlName="firstname" (change)="(!nameChanged || formGroup.controls.name !== '') && setUserName()"/>
			</bb-form-element>
			
			<bb-form-element [control]="formGroup.controls.lastname" [label]="'LAST_NAME' | translate">
				<input type="text" required formControlName="lastname" (change)="!nameChanged && setUserName()"/>
			</bb-form-element>
			
			<bb-form-element [control]="formGroup.controls.name" [label]="'USERNAME' | translate" [helpMessage]="'HELP.USERNAME_EXPLANATION_UNIQUE' | translate">
				<input type="text" required [formControl]="formGroup.controls.name" formControlName="name" (focus)="nameFocussed=true" (blur)="nameFocussed=false" (change)="nameFocussed && (nameChanged=true)"/>
			</bb-form-element>

			<bb-form-element [control]="formGroup.controls.email" [label]="'EMAIL' | translate" [helpMessage]="'HELP.EMAIL_EXPLANATION_UNIQUE' | translate">
				<input type="email" required formControlName="email"/>
			</bb-form-element>
			
			<bb-form-element [control]="formGroup.controls.password" [label]="'PASSWORD' | translate" *ngIf="isNew" [helpMessage]="'HELP.PASSWORD_EXPLANATION_EMAIL' | translate">
				<input type="password" formControlName="password"/>
			</bb-form-element>

			<bb-form-element [control]="formGroup.controls.repeat_password" [label]="'REPEAT_PASSWORD' | translate" *ngIf="isNew">
				<input type="password" formControlName="repeat_password"/>
			</bb-form-element>

			<ng-container *ngIf="!isNew">
				<h3>{{'DETAILS' | translate}}</h3>
				<bb-form-element [label]="'ID' | translate">
					<div class="input">{{ user.id }}</div>
				</bb-form-element>
				<bb-form-element [label]="'CREATED' | translate">
					<div class="input" [title]="user.createddate | bbDate">{{ user.createddate | bbDate:'relative'}}</div>
				</bb-form-element>
				<bb-form-element [label]="'UPDATED' | translate">
					<div class="input" [title]="user.updateddate | bbDate">{{ user.updateddate | bbDate:'relative'}}</div>
				</bb-form-element>
				<bb-form-element [label]="'HOME_PUBLICATION' | translate">
					<div class="input">
						<a [href]="'//'+publication.vhost" target="_blank" *ngFor="let publication of user.publications" [hidden]="!publication.home" [title]="publication.vhost">{{publication.label || publication.name }}</a>
					</div>
				</bb-form-element>
				<bb-form-element [label]="'OTHER_PUBLICATIONS' | translate" *ngIf="user.publications && user.publications.length > 1">
					<div class="input">
						<a [href]="'//'+publication.vhost" target="_blank" *ngFor="let publication of user.publications" [hidden]="publication.home" [title]="publication.vhost">{{publication.label || publication.name }} </a>
					</div>
				</bb-form-element>
				<bb-form-element [label]="'RESET_PASSWORD' | translate">
					<div [ngClass]="{disabled: !putRight}" class="input">
						<button class="button" (click)="resetPassword()"><i class="fa fa-refresh"></i> {{ 'RESET_PASSWORD' | translate }}</button>
					</div>
				</bb-form-element>
			</ng-container>
		</div>
		<div class="right-column" [class.old-roles]="legacyRoles">
			<h3>{{'ROLES' | translate}}</h3>
			<bb-form-element [control]="formGroup.controls.roles">
				<input type="hidden" formArrayName="roles"/>
				<ul class="role-list">
					<li *ngFor="let role of roles; let i = index">
						<label [class.no-pointer]="role.disabled">
							<bb-check [(ngModel)]="role.checked" [checked]="role.checked" (ngModelChange)="roleChanged(role, $event)"
								[ngModelOptions]="{standalone: true}" [disabled]="role.disabled"></bb-check>
							<span>
								{{role.label || role.name}}
								<bb-info *ngIf="!legacyRoles" [contents]="role.help | translate" [icon]="'info'"></bb-info>
							</span>
						</label>
					</li>
					<ng-container *ngIf="extraRoles">
						<h3 class="access-roles">{{'ACCESS_ROLES' | translate}}</h3>
						<li *ngFor="let role of extraRoles">
							<label>
								<bb-check [(ngModel)]="role.checked" [checked]="role.checked" (ngModelChange)="roleChanged(role, $event)"
									[ngModelOptions]="{standalone: true}"></bb-check>
								<span>
									{{role.label || role.name}}
									<bb-info [contents]="role.help | translate" [icon]="'info'"></bb-info>
								</span>
							</label>
						</li>
					</ng-container>
				</ul>
			</bb-form-element>
			<button [hasPermission]="'root'" class="button" (click)="switchPermission()"><i class="fa fa-user"></i>{{ (legacyRoles ? 'MODERN_ROLES' : 'LEGACY_ROLES') | translate }}</button>
		
			<bb-entity-details
				[entity]="entity"
			></bb-entity-details>
		</div>
	</div>
</form>
<bb-actions-bar (onSave)="save($event)" (onCancel)="cancel()" (onDelete)="delete($event)" [formGroup]="formGroup" [entity]="entity"></bb-actions-bar>
